class SizeGuideModal extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    const hash = window.location?.hash

    if (hash === '#size-guide') {
      this.handleTrigger()
    }
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.listeners.add(
      this.externalEls.trigger.element,
      'click',
      this.handleTrigger,
    )

    this.els.close.elements.forEach((close) => {
      this.listeners.add(close, 'click', this.handleClose)
    })
  }

  handleTrigger () {
    this.setAttribute('data-modal-open', 'true')
    document.body.classList.toggle('util-SiteOverflowed', true)
    this.setAttribute('aria-hidden', 'false')
  }

  handleClose () {
    this.setAttribute('aria-hidden', 'true')
    document.body.classList.toggle('util-SiteOverflowed', false)
  }
}

if (!customElements.get('size-guide-modal')) {
  customElements.define('size-guide-modal', SizeGuideModal)
}
